import { CustomerMeal } from './CustomerMeal'
import { ResponsePattern } from './ResponsesDTO'

export class CustomerMealRequestDTO {

    customerMeal : CustomerMeal
    pattern : ResponsePattern

    constructor(customerMeal : CustomerMeal, pattern : ResponsePattern) {
        this.customerMeal = customerMeal
        this.pattern = pattern
    }

}